import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import RankingPrepare from '../RankingPrepare/RankingPrepare'
import RankingResult from '../RankingResult/RankingResult'

import './Ranking.css'

const Ranking = ({ index, ranking, isLoading }) => {
  let contents
  if (index == 0 || ranking.length == 0) {
    contents = <RankingPrepare isLoading={isLoading}>結果発表</RankingPrepare>
  } else {
    const result = ranking[index - 1]
    contents = result ? (
      <RankingResult rank={result.rank} name={result.name} correctCount={result.correct_count} time={result.time} />
    ) : (
      <div />
    )
  }
  return <div styleName="container">{contents}</div>
}

Ranking.propTypes = {
  index: PropTypes.number.isRequired,
  ranking: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired
}

export default compose(pure)(Ranking)
